// import Layout from '@/layout'
import BasicLayout from '@/layout/BasicLayout.vue'

const jobRouter = {
  path: '/job',
  component: BasicLayout,
  children: [
    {
      path: '/job/plan',
      component: () => import('../../views/job/index.vue'),
      children: [
        {
          path: '/job/plan/production-order-process/1',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-order-process/2',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-order-process/3',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-order-process/4',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-order-process/5',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-order-process/6',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-order-process/7',
          component: () => import('../../views/job/plan/index'),
        },
        {
          path: '/job/plan/production-plan/1',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        {
          path: '/job/plan/production-plan/2',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        {
          path: '/job/plan/production-plan/3',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        {
          path: '/job/plan/production-plan/4',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        {
          path: '/job/plan/production-plan/5',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        {
          path: '/job/plan/production-plan/6',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        {
          path: '/job/plan/production-plan/7',
          component: () => import('../../views/job/production-plan/index.vue'),
        },
        // {
        //   path: '/job/plan/production-statistics/1',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        // {
        //   path: '/job/plan/production-statistics/2',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        // {
        //   path: '/job/plan/production-statistics/3',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        // {
        //   path: '/job/plan/production-statistics/4',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        // {
        //   path: '/job/plan/production-statistics/5',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        // {
        //   path: '/job/plan/production-statistics/6',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        // {
        //   path: '/job/plan/production-statistics/7',
        //   component: () => import('../../views/job/production-statistics/index.vue'),
        // },
        {
          path: '/job/plan/language-setting',
          component: () => import('../../views/job/language-setting/index'),
        },
        {
          path: '/job/plan/process-assign/1',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
        {
          path: '/job/plan/process-assign/2',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
        {
          path: '/job/plan/process-assign/3',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
        {
          path: '/job/plan/process-assign/4',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
        {
          path: '/job/plan/process-assign/5',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
        {
          path: '/job/plan/process-assign/6',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
        {
          path: '/job/plan/process-assign/7',
          component: () => import('../../views/job/process-dispatch/index.vue'),
        },
      ]
    },
    {
      path: '/job/plan/production-statistics',
      component: () => import('../../views/job/production-statistics/setting.vue'),
      children: [
        //计划进度
        {
          path: '/job/plan/plan-schedule',
          component: () => import('@/views/job/production-statistics/components/plan-schedule/index.vue'),
        },
        //超期分析
        {
          path: '/job/plan/overdue-analysis',
          component: () => import('@/views/job/production-statistics/components/overdue-analysis/index.vue'),
        },
        //在制品分析
        {
          path: '/job/plan/wip-analysis',
          component: () => import('@/views/job/production-statistics/components/wip-analysis/index.vue'),
        },
        //人员业绩分析
        {
          path: '/job/plan/personnel-performance-analysis',
          component: () => import('@/views/job/production-statistics/components/personnel-performance-analysis/index.vue'),
        },
        //工序分析
        {
          path: '/job/plan/process-analysis',
          component: () => import('@/views/job/production-statistics/components/process-analysis/index.vue'),
        },
        //工位生产日历
        {
          path: '/job/plan/production-calendar',
          component: () => import('@/views/job/production-statistics/components/production-calendar/index.vue'),
        },
        //生产综合统计
        {
          path: '/job/plan/production-comprehensive-statistics',
          component: () => import('@/views/job/production-statistics/components/production-comprehensive-statistics/index.vue'),
        },
      ]
    }
  ]
}

export default jobRouter
